import React from 'react';

const DjsCell: React.FC<CellProps<EventListItem>> = () => <div />;

export default DjsCell;
